import './stylesheets/onepage.scss'
import './oldies/global/cookie.js';

const isElementInViewport = (el) => {
  var rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const handleScroll = (techSwiper) => {
  let lastScrollTop = 0;

  return function() {
    let element = techSwiper.slides[0].querySelector('.kpis')
    const nav = document.getElementsByTagName("nav")[0];
    if (!nav || !element) { return; }

    if (isElementInViewport(element)) {
        element.classList.add('visible');
        window.removeEventListener('scroll', handleScroll);
    }
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 100) {
      // Scrolling down
      nav.classList.add("small-navbar");
    } else {
      // Scrolling up
      nav.classList.remove("small-navbar");
    }
  }
}

document.addEventListener("turbo:load", function() {
  document.selectColor = (sel) => {
    sel.style.color = (sel.options[sel.selectedIndex].value == "") ? "#959595" : "black";
  }
});

document.addEventListener("turbo:load", function() {
  if(document.querySelector('.tech-swiper')) {
    const techSwiper = new Swiper('.tech-swiper', {
      speed: 400,
      spaceBetween: 0,
      effect: 'fade',
      autoHeight: false,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.slide-button-next',
        prevEl: '.slide-button-prev',
      },
      preloadImages: false,
      updateOnImagesReady: false,
      on: {
        slideChangeTransitionEnd: function(evt) {
          evt.slides[evt.activeIndex].querySelector('.kpis').classList.add('visible')
        }
      },
    });
  
    window.addEventListener('scroll', handleScroll(techSwiper) );

    
    function scrollToAnchor(targetId) {
      if (targetId !== "") {
        window.location.hash = targetId
        // Get the target element with the same id as the hash
        const targetElement = document.querySelector('[data-anchor="' + targetId + '"]');
        if (targetElement) {
            // Scroll to the target element
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }


    function clickToAnchor(event) {
      event.preventDefault();
      console.log(event)
      let targetId = this.getAttribute('href').split('#')[1];
      scrollToAnchor(targetId)
    }

    var anchorElements = document.querySelectorAll('.scroll-link a');
    anchorElements.forEach(function(anchorElement) {
        anchorElement.addEventListener('click', clickToAnchor);
    });

    const targetId =  window.location.hash.substring(1)
    scrollToAnchor(targetId)
  }
});